module.exports = __webpack_public_path__ + "img/img_32389_0_307.6be55b59.png";